import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2';

import CommonTooltip from '../../../../../../../../../component/common/CommonTooltip';

const AssociationTable = (props) => {

    const { product_name, feature_list } = props;

    let featureListHtml = '';
    if(feature_list.length > 0){
        featureListHtml = feature_list.map((featureData, i) => 
            <span className="badge badge-light-dark fs-7 fw-bold me-2 text-gray-600 mb-2" key={uuidv4()}>
                <span className="text-gray-600 fw-bold fs-6">
                    {featureData.label}
                </span>
            </span>
        )
    }
    const associationDeleteOnClick = async (product_name) => {
        const associationDeleteSwal = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won’t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });
        if(associationDeleteSwal.isConfirmed){
            props.associationDelete(product_name)
        }
    }
    return(
        <>
            <tr>
                <td>
                    {product_name}
                </td>
                <td>
                   {featureListHtml}
                </td>
                <td className='d-flex float-end'>
                    <div 
                        className='cursor-pointer'
                        onClick={(e) => { e.preventDefault(); associationDeleteOnClick(product_name)}} 
                        data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Delete"
                    >
                        <FontAwesomeIcon icon={faTrash} className='text-danger fs-3' />
                    </div>
                </td>
            </tr>
            <CommonTooltip
                id="common_tooltip"
                style= {{ backgroundColor: "black", color: "white", fontSize:"14px" }}
                place="top"
                float={true}
            />
        </>
    )
}

const ProductFeatureAssociationList = (props) => {
    const { associationData } = props;
    let associationTableHtml = '';
    if (Object.keys(associationData).length > 0) {
        associationTableHtml = Object.entries(associationData).map(([key, value]) => (
            <AssociationTable
                key={uuidv4()}
                product_name={key}
                feature_list={value.feature_list}
                associationDelete={props.associationDelete}
            />
        ));
    }
    return (
        <>
            {
                Object.keys(associationData).length > 0 &&
                <>
                    <div className='row'>
                        <div className='col-md-12'>
                            <table className="table table-row-dashed align-middle gs-0 gy-4">
                                <thead>
                                    <tr className='fs-7 fw-bold border-0 text-gray-400'>
                                        <th className="">Product</th>
                                        <th className="">Feature</th>
                                        <th className=""></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {associationTableHtml}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>
            }
        </>
    )
}

export default ProductFeatureAssociationList